import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import { env } from "./lib/env";
import { registerServiceWorker } from "./lib/registerServiceWorker";
import App from "./App";

// Initialize Sentry
if (env.SENTRY_DSN) {
  Sentry.init({
    dsn: env.SENTRY_DSN,
    environment: import.meta.env.MODE,

    integrations: [
      Sentry.browserTracingIntegration({
        enableInp: true,
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    release: env.APP_VERSION,

    beforeSend(event) {
      if (import.meta.env.DEV) {
        console.log('Sentry event (dev mode, not sent):', event);
        return null;
      }
      return event;
    },

    ignoreErrors: [
      'top.GLOBALS',
      'NetworkError',
      'Failed to fetch',
      'Hydration failed',
    ],
  });
} else {
  console.warn('Sentry DSN not configured. Error tracking disabled.');
}

createRoot(document.getElementById("root")!).render(<App />);

if (import.meta.env.PROD) {
  registerServiceWorker();
}
